import { IGetIncreaseBetsPositionsCountByAnnouncementResponse } from '../../../../repositories/auction/v2/get-increase-bets-positions-count-by-announcement';
import { IConcurrencyType, IBetPosition } from '../../../../redux/reducers/betPosition/types';

export function mapSuccessResponse(response: IGetIncreaseBetsPositionsCountByAnnouncementResponse): IBetPosition {
  const {
    concurrencyTypes,
    currentSerpPage,
    increaseBetsPositionsCount,
    serpPosition,
    betFullConcurrency,
    betPageFullConcurrency,
    betPositionFullConcurrency,
    betServiceConcurrency,
    topBet,
  } = response;

  return {
    concurrencyTypes: (concurrencyTypes as unknown) as IConcurrencyType[],
    currentSerpPage,
    increaseBetsPositionsCount,
    serpPosition,
    betFullConcurrency: betFullConcurrency ?? null,
    betPageFullConcurrency: betPageFullConcurrency ?? null,
    betPositionFullConcurrency: betPositionFullConcurrency ?? null,
    betServiceConcurrency: betServiceConcurrency ?? null,
    topBet: topBet ?? null,
  };
}
